export default __webpack_public_path__ + "static/Group 1304-eaee4e520d0c8f1cb3d0c228fdc55f55.png";